<template>
	<div class="search">
		<form @submit.prevent="search">
			<managing-section>
				<managing-box title="닉네임">
					<input v-model="nickName" type="text" />
				</managing-box>
				<managing-box title="성별">
					<RadioList
						v-model="gender"
						value-name="name"
						:radio-list="genderList"
					/>
				</managing-box>
				<managing-box title="나이" :horizontal-mode="true">
					<selector
						v-model="minAge"
						:option-list="minAgeList"
						value-key="id"
						class="search__birth-year"
					/>
					~
					<selector
						v-model="maxAge"
						:option-list="maxAgeList"
						value-key="id"
						class="search__birth-year"
					/>
				</managing-box>
				<managing-box title="가입일">
					<DateRange v-model="date" type="date" />
				</managing-box>
				<managing-box title="이메일주소">
					<input type="email" v-model="email" />
				</managing-box>
				<managing-box title="피부타입">
					<selector v-model="skinType" :option-list="skinTypeList" />
				</managing-box>
				<managing-box title="거주지역">
					<region-selector v-model="regionObj" />
				</managing-box>
				<managing-box title="디바이스">
					<RadioList
						v-model="deviceType"
						:radio-list="deviceTypeList"
					/>
				</managing-box>
			</managing-section>
			<div class="btn-wrap-main">
				<button
					type="submit"
					class="btn-main blue"
					v-text="'검색하기'"
				/>
				<button type="button" class="btn-main" @click="init">
					다시작성
				</button>
			</div>
		</form>
		<managing-section :is-table="true">
			<table class="table-main">
				<thead>
					<tr>
						<th>항번</th>
						<th>닉네임</th>
						<th>나이</th>
						<th>피부</th>
						<th>성별</th>
						<th>선택</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in list" :key="item.idRegister">
						<td>{{ item.idRegister }}</td>
						<td>{{ item.nickName }}</td>
						<td>{{ item.age }}</td>
						<td>{{ item.skinType }}</td>
						<td>{{ item.gender }}</td>
						<td>
							<button
								class="btn blue"
								@click="selectWriter(item)"
							>
								선택
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				:totalItem="totalItem"
				:offset="offset"
				:limit="limit"
				slot="pagination"
				@to="paging"
			/>
		</managing-section>
	</div>
</template>
<script>
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import RadioList from '@/components/RadioList';
	import Selector from '@/components/Selector';
	import DateRange from '@/components/DateRange';
	import RegionSelector from '@/components/RegionSelector';
	import PaginationBox from '@/components/PaginationBox';

	export default {
		name: 'WriterSearch',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			Selector,
			DateRange,
			RegionSelector,
			PaginationBox,
		},
		data() {
			return {
				paramKeys: [
					'nickName',
					'gender',
					'minAge',
					'maxAge',
					'email',
					'skinType',
					'deviceType',
				],
				nickName: '',
				gender: null,
				minAge: null,
				maxAge: null,
				date: { from: '', to: '' },
				email: '',
				skinType: null,
				regionObj: {
					location: null,
					region: null,
				},
				deviceTypeList: [
					{ id: null, value: '전체' },
					{ id: 'aos', value: '안드로이드' },
					{ id: 'ios', value: '아이폰' },
				],
				deviceType: null,
				limit: 10,
				offset: 0,
				list: null,
				totalItem: 0,
			};
		},
		computed: {
			...mapState({
				params: state => state.modal.params,
			}),
			...mapGetters({
				getListAddNull: 'getListAddNull',
				getItemById: 'getItemById',
			}),
			genderList() {
				return this.getListAddNull('gender');
			},
			minAgeList() {
				return this.getListAddNull(
					'birthYear',
					null,
					'--- 시작나이 ---'
				);
			},
			maxAgeList() {
				return this.getListAddNull('birthYear', null, '--- 끝나이 ---');
			},
			skinTypeList() {
				return this.getListAddNull('skinType');
			},
		},
		methods: {
			dateToISOString(date, isMax) {
				return date
					? isMax
						? moment(date, 'YYYY-MM-DD')
								.endOf('date')
								.utc()
								.toISOString()
						: moment(date, 'YYYY-MM-DD').utc().toISOString()
					: '';
			},
			async getList() {
				try {
					const params = this.paramKeys.reduce(
						(acc, key) => {
							if (this[key]) {
								acc[key] = this[key];
							}
							return acc;
						},
						{
							locationCode: this.regionObj.location,
							limit: this.limit,
							offset: this.offset,
							minDate: this.dateToISOString(this.date.from),
							maxDate: this.dateToISOString(this.date.from, true),
						}
					);
					const { data } = await this.$axiosAdmin2.get(
						'/v3/api/register/search/all',
						{ params }
					);
					this.list = data.data.map(item => ({
						...item,
						skinType: this.getItemById('skinType', item.skinType)
							.name,
						gender: this.getItemById('gender', item.gender).name,
					}));
					this.totalItem = data.contentTotal;
				} catch (err) {
					console.error(err);
				}
			},
			async search() {
				this.offset = 0;
				this.getList();
			},
			init() {
				this.nickName = '';
				this.gender = this.genderList[0].id;
				this.minAge = null;
				this.maxAge = null;
				this.date = { from: '', to: '' };
				this.email = '';
				this.skinType = this.skinTypeList[0].id;
				this.regionObj = {
					region: null,
					location: null,
				};
				this.deviceType = this.deviceTypeList[0].id;
			},
			selectWriter({ idRegister, nickName }) {
				this.params.selectWriter({ idRegister, nickName });
				this.$store.commit('modal/toggleModal', { id: null });
			},
			paging({ offset }) {
				this.offset = offset;
				this.getList();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.search__birth-year {
		margin: 0 8px;

		&:first-child {
			margin-left: 0;
		}
	}
</style>
